<form [formGroup]="form" class="mat-typography" *ngIf="defaultPolicy && form; else notFound">

    <mat-accordion>

        <!-- Section 1: Bulk Email Threshold -->
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full flex justify-between">
                    <mat-panel-title class="font-bold">
                        Bulk Email Threshold
                    </mat-panel-title>
                    <div>
                        <sway-baseline-status [hasError]="errorsString.includes('BulkThreshold!')">
                        </sway-baseline-status>
                    </div>
                </div>
            </mat-expansion-panel-header>

            <div>
                <table>
                    <thead>
                        <tr>
                            <th>Field</th>
                            <th>Current Value</th>
                            <th>Desired Value</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Bulk Email Threshold
                                <mat-icon [matTooltip]="tooltips.BulkThreshold">info</mat-icon>
                            </td>
                            <td>{{defaultPolicy?.BulkThreshold}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <input matInput type="number" formControlName="BulkThreshold" min="1" max="9" />
                                    <mat-error *ngIf="form.get('BulkThreshold').hasError('required')">Value is
                                        required</mat-error>
                                    <mat-error *ngIf="form.get('BulkThreshold').hasError('min')">Minimum value is
                                        1</mat-error>
                                    <mat-error *ngIf="form.get('BulkThreshold').hasError('max')">Maximum value is
                                        9</mat-error>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('BulkThreshold!')"></sway-baseline-status>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-expansion-panel>

        <!-- Section 2: Increase Spam Score -->
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full flex justify-between">
                    <mat-panel-title class="font-bold">
                        Increase Spam Score
                    </mat-panel-title>
                    <div>
                        <sway-baseline-status [hasError]="errorsString.includes('IncreaseScoreWithImageLinks!') || errorsString.includes('IncreaseScoreWithNumericIps!') || errorsString.includes('IncreaseScoreWithRedirectToOtherPort!') || errorsString.includes('IncreaseScoreWithBizOrInfoUrls!')">
                        </sway-baseline-status>
                    </div>
                </div>
            </mat-expansion-panel-header>

            <div>
                <table>
                    <thead>
                        <tr>
                            <th>Field</th>
                            <th>Current Value</th>
                            <th>Desired Value</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Image Links to Remote Websites</td>
                            <td>{{defaultPolicy?.IncreaseScoreWithImageLinks}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="IncreaseScoreWithImageLinks">
                                        <mat-option value="On">On</mat-option>
                                        <mat-option value="Off">Off</mat-option>
                                        <mat-option value="Test">Test</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('IncreaseScoreWithImageLinks!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>Numeric IP Address in URL</td>
                            <td>{{defaultPolicy?.IncreaseScoreWithNumericIps}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="IncreaseScoreWithNumericIps">
                                        <mat-option value="On">On</mat-option>
                                        <mat-option value="Off">Off</mat-option>
                                        <mat-option value="Test">Test</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('IncreaseScoreWithNumericIps!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>URL Redirect to Other Port</td>
                            <td>{{defaultPolicy?.IncreaseScoreWithRedirectToOtherPort}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="IncreaseScoreWithRedirectToOtherPort">
                                        <mat-option value="On">On</mat-option>
                                        <mat-option value="Off">Off</mat-option>
                                        <mat-option value="Test">Test</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('IncreaseScoreWithRedirectToOtherPort!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>URL to .biz or .info Websites</td>
                            <td>{{defaultPolicy?.IncreaseScoreWithBizOrInfoUrls}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="IncreaseScoreWithBizOrInfoUrls">
                                        <mat-option value="On">On</mat-option>
                                        <mat-option value="Off">Off</mat-option>
                                        <mat-option value="Test">Test</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('IncreaseScoreWithBizOrInfoUrls!')"></sway-baseline-status>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-expansion-panel>

        <!-- Section 3: Mark as Spam -->
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full flex justify-between">
                    <mat-panel-title class="font-bold">
                        Mark as Spam
                    </mat-panel-title>
                    <div>
                        <sway-baseline-status [hasError]="errorsString.includes('MarkAsSpamEmptyMessages!') || errorsString.includes('MarkAsSpamEmbedTagsInHtml!') || errorsString.includes('MarkAsSpamJavaScriptInHtml!') || errorsString.includes('MarkAsSpamObjectTagsInHtml!') || errorsString.includes('MarkAsSpamFormTagsInHtml!') || errorsString.includes('MarkAsSpamFramesInHtml!') || errorsString.includes('MarkAsSpamWebBugsInHtml!') || errorsString.includes('MarkAsSpamSensitiveWordList!') || errorsString.includes('MarkAsSpamSpfRecordHardFail!') || errorsString.includes('MarkAsSpamFromAddressAuthFail!') || errorsString.includes('MarkAsSpamNdrBackscatter!') || errorsString.includes('TestModeAction!') || errorsString.includes('TestModeBccToRecipients')">
                        </sway-baseline-status>
                    </div>
                </div>
            </mat-expansion-panel-header>

            <div>
                <table>
                    <thead>
                        <tr>
                            <th>Field</th>
                            <th>Current Value</th>
                            <th>Desired Value</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Empty Messages</td>
                            <td>{{defaultPolicy?.MarkAsSpamEmptyMessages}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="MarkAsSpamEmptyMessages">
                                        <mat-option value="On">On</mat-option>
                                        <mat-option value="Off">Off</mat-option>
                                        <mat-option value="Test">Test</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('MarkAsSpamEmptyMessages!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>Embedded Tags in HTML</td>
                            <td>{{defaultPolicy?.MarkAsSpamEmbedTagsInHtml}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="MarkAsSpamEmbedTagsInHtml">
                                        <mat-option value="On">On</mat-option>
                                        <mat-option value="Off">Off</mat-option>
                                        <mat-option value="Test">Test</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('MarkAsSpamEmbedTagsInHtml!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>JavaScript or VBScript in HTML</td>
                            <td>{{defaultPolicy?.MarkAsSpamJavaScriptInHtml}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="MarkAsSpamJavaScriptInHtml">
                                        <mat-option value="On">On</mat-option>
                                        <mat-option value="Off">Off</mat-option>
                                        <mat-option value="Test">Test</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('MarkAsSpamJavaScriptInHtml!')"></sway-baseline-status>
                            </td>
                        </tr>


                        <tr>
                            <td>Form Tags in HTML</td>
                            <td>{{defaultPolicy?.MarkAsSpamFormTagsInHtml}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="MarkAsSpamFormTagsInHtml">
                                        <mat-option value="On">On</mat-option>
                                        <mat-option value="Off">Off</mat-option>
                                        <mat-option value="Test">Test</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('MarkAsSpamFormTagsInHtml!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>Frame or Iframe Tags in HTML</td>
                            <td>{{defaultPolicy?.MarkAsSpamFramesInHtml}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="MarkAsSpamFramesInHtml">
                                        <mat-option value="On">On</mat-option>
                                        <mat-option value="Off">Off</mat-option>
                                        <mat-option value="Test">Test</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('MarkAsSpamFramesInHtml!')"></sway-baseline-status>
                            </td>
                        </tr>





                        <tr>
                            <td>Web Bugs in HTML</td>
                            <td>{{defaultPolicy?.MarkAsSpamWebBugsInHtml}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="MarkAsSpamWebBugsInHtml">
                                        <mat-option value="On">On</mat-option>
                                        <mat-option value="Off">Off</mat-option>
                                        <mat-option value="Test">Test</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('MarkAsSpamWebBugsInHtml!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>Object Tags in HTML</td>
                            <td>{{defaultPolicy?.MarkAsSpamObjectTagsInHtml}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="MarkAsSpamObjectTagsInHtml">
                                        <mat-option value="On">On</mat-option>
                                        <mat-option value="Off">Off</mat-option>
                                        <mat-option value="Test">Test</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('MarkAsSpamObjectTagsInHtml!')"></sway-baseline-status>
                            </td>
                        </tr>


                        <tr>
                            <td>
                                Sensitive Words
                                <mat-icon [matTooltip]="tooltips.MarkAsSpamSensitiveWordList">info</mat-icon>
                            </td>
                            <td>{{defaultPolicy?.MarkAsSpamSensitiveWordList}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="MarkAsSpamSensitiveWordList">
                                        <mat-option value="On">On</mat-option>
                                        <mat-option value="Off">Off</mat-option>
                                        <mat-option value="Test">Test</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('MarkAsSpamSensitiveWordList!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                SPF Record: Hard Fail
                                <mat-icon [matTooltip]="tooltips.MarkAsSpamSpfRecordHardFail">info</mat-icon>
                            </td>
                            <td>{{defaultPolicy?.MarkAsSpamSpfRecordHardFail}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="MarkAsSpamSpfRecordHardFail">
                                        <mat-option value="On">On</mat-option>
                                        <mat-option value="Off">Off</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('MarkAsSpamSpfRecordHardFail!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                Sender ID Filtering: Hard Fail
                                <mat-icon [matTooltip]="tooltips.MarkAsSpamFromAddressAuthFail">info</mat-icon>
                            </td>
                            <td>{{defaultPolicy?.MarkAsSpamFromAddressAuthFail}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="MarkAsSpamFromAddressAuthFail">
                                        <mat-option value="On">On</mat-option>
                                        <mat-option value="Off">Off</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('MarkAsSpamFromAddressAuthFail!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>Backscatter</td>
                            <td>{{defaultPolicy?.MarkAsSpamNdrBackscatter}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="MarkAsSpamNdrBackscatter">
                                        <mat-option value="On">On</mat-option>
                                        <mat-option value="Off">Off</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('MarkAsSpamNdrBackscatter!')"></sway-baseline-status>
                            </td>
                        </tr>



                        <tr>
                            <td>Contains Specific Languages</td>
                            <td>
                                {{defaultPolicy?.EnableLanguageBlockList ? 'On' : 'Off'}}
                                <span *ngIf="defaultPolicy?.EnableLanguageBlockList">: {{getLanguageNames(defaultPolicy?.LanguageBlockList)}}</span>
                            </td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="EnableLanguageBlockList">
                                        <mat-option [value]="true">On</mat-option>
                                        <mat-option [value]="false">Off</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <ng-select *ngIf="formValue?.EnableLanguageBlockList === true"
                                    formControlName="LanguageBlockList"
                                    [multiple]="true"
                                    [items]="languages"
                                    bindValue="code"
                                    bindLabel="name"
                                    [appendTo]="'body'"
                                    placeholder="Select languages">
                                    <ng-template ng-option-tmp let-item="item">
                                        {{item.name}} ({{item.code}})
                                    </ng-template>
                                </ng-select>
                                <small class="error" *ngIf="formValue?.EnableLanguageBlockList === true && form.get('LanguageBlockList').hasError('required')">At least one language is required</small>
                            </td>
                            <td>
                                <sway-baseline-status
                                    [hasError]="errorsString.includes('EnableLanguageBlockList') || errorsString.includes('LanguageBlockList')" >
                                </sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>From These Countries</td>
                            <td>
                                {{defaultPolicy?.EnableRegionBlockList ? 'On' : 'Off'}}
                                <span *ngIf="defaultPolicy?.EnableRegionBlockList">: {{getCountryNames(defaultPolicy?.RegionBlockList)}}</span>
                            </td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="EnableRegionBlockList">
                                        <mat-option [value]="true">On</mat-option>
                                        <mat-option [value]="false">Off</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <ng-select *ngIf="formValue?.EnableRegionBlockList === true"
                                    formControlName="RegionBlockList"
                                    [multiple]="true"
                                    [items]="countries"
                                    bindValue="alpha-2"
                                    bindLabel="name"
                                    [appendTo]="'body'"
                                    placeholder="Select countries">
                                    <ng-template ng-option-tmp let-item="item">
                                        {{item.name}} ({{item['alpha-2']}})
                                    </ng-template>
                                </ng-select>
                                <small class="error" *ngIf="formValue?.EnableRegionBlockList === true && form.get('RegionBlockList').hasError('required')">At least one country is required</small>
                            </td>
                            <td>
                                <sway-baseline-status
                                    [hasError]="errorsString.includes('EnableRegionBlockList!') || errorsString.includes('RegionBlockList!')" >
                                </sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>
                                Test Mode
                                <mat-icon [matTooltip]="tooltips.TestModeAction">info</mat-icon>
                            </td>
                            <td>
                                <div>
                                    {{testModeActionLabels[defaultPolicy?.TestModeAction] ?? defaultPolicy?.TestModeAction}}
                                </div>
                                <div *ngIf="defaultPolicy?.TestModeAction === 'BccMessage'"> {{defaultPolicy?.TestModeBccToRecipients?.join(', ') || '-'}}</div>
                            </td>
                            <td>
                                <mat-form-field appearance="outline" *ngIf="!readOnly; else testModeReadonly">
                                    <mat-select formControlName="TestModeAction">
                                        <mat-option value="None">None</mat-option>
                                        <mat-option value="AddXHeader">Add X-Header</mat-option>
                                        <mat-option value="BccMessage">Send Bcc Message</mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <ng-template #testModeReadonly>
                                    <div>{{testModeActionLabels[form.get('TestModeAction').value] ?? form.get('TestModeAction').value}}</div>
                                </ng-template>
                                <ng-container *ngIf="formValue?.TestModeAction === 'BccMessage'">

                                    <ng-container *ngIf="!readOnly || override?.includes('TestModeBccToRecipients'); else bccReadonly">
                                        <mat-form-field appearance="outline">
                                            <input matInput formControlName="TestModeBccToRecipients" placeholder="email@example.com" />
                                            <mat-error *ngIf="form.get('TestModeBccToRecipients').hasError('required')">BCC recipient email is required</mat-error>
                                            <mat-error *ngIf="form.get('TestModeBccToRecipients').hasError('email')">Must be a valid email address</mat-error>
                                        </mat-form-field>
                                    </ng-container>

                                    <ng-template #bccReadonly>
                                        <div>{{form.get('TestModeBccToRecipients').value || '-'}}</div>
                                    </ng-template>
                                </ng-container>
                            </td>
                            <td>
                                <sway-baseline-status
                                    [hasError]="errorsString.includes('TestModeAction!') || errorsString.includes('TestModeBccToRecipients')" >
                                </sway-baseline-status>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </mat-expansion-panel>

        <!-- Section 4: Actions -->
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full flex justify-between">
                    <mat-panel-title class="font-bold">
                        Actions
                    </mat-panel-title>
                    <div>
                        <sway-baseline-status
                        [hasError]="
                            errorsString.includes('SpamAction!') ||
                            errorsString.includes('SpamQuarantineTag!') ||
                            errorsString.includes('HighConfidenceSpamAction!')
                            || errorsString.includes('HighConfidenceSpamQuarantineTag!')
                            || errorsString.includes('PhishSpamAction!')
                            || errorsString.includes('PhishQuarantineTag!') || errorsString.includes('HighConfidencePhishAction!') || errorsString.includes('HighConfidencePhishQuarantineTag!') || errorsString.includes('BulkSpamAction!') || errorsString.includes('BulkQuarantineTag!') || errorsString.includes('IntraOrgFilterState!') || errorsString.includes('InlineSafetyTipsEnabled!') || errorsString.includes('QuarantineRetentionPeriod!')
                            || errorsString.includes('AddXHeaderValue!')
                            || errorsString.includes('ModifySubjectValue!')
 || errorsString.includes('RedirectToRecipients') || errorsString.includes('PhishZapEnabled!')

 || hasRedirectToRecipientsError || errorsString.includes('SpamZapEnabled!')


">
                        </sway-baseline-status>
                    </div>
                </div>
            </mat-expansion-panel-header>

            <div>
                <table>
                    <thead>
                        <tr>
                            <th>Field</th>
                            <th>Current Value</th>
                            <th>Desired Value</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Spam</td>
                            <td>{{spamActionLabels[defaultPolicy?.SpamAction] ?? defaultPolicy?.SpamAction}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="SpamAction">
                                        <mat-option value="MoveToJmf">Move message to junk email folder</mat-option>
                                        <mat-option value="AddXHeader">Add X-header</mat-option>
                                        <mat-option value="ModifySubject">Prepend subject line with text</mat-option>
                                        <mat-option value="Redirect">Redirect message to email address</mat-option>
                                        <mat-option value="Delete">Delete message</mat-option>
                                        <mat-option value="Quarantine">Quarantine message</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="outline" *ngIf="formValue?.SpamAction === 'Quarantine'">
                                    <mat-label>Quarantine Policy</mat-label>
                                    <mat-select formControlName="SpamQuarantineTag">
                                        <mat-option *ngFor="let policy of quarantinePolicyLookup$ | async"
                                            [value]="policy.Name">
                                            {{policy.Name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="(formValue.SpamAction !== defaultPolicy?.SpamAction) || errorsString.includes('/SpamQuarantineTag!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>High Confidence Spam</td>
                            <td>{{spamActionLabels[defaultPolicy?.HighConfidenceSpamAction] ??
                                defaultPolicy?.HighConfidenceSpamAction}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="HighConfidenceSpamAction">
                                        <mat-option value="MoveToJmf">Move message to junk email folder</mat-option>
                                        <mat-option value="AddXHeader">Add X-header</mat-option>
                                        <mat-option value="ModifySubject">Prepend subject line with text</mat-option>
                                        <mat-option value="Redirect">Redirect message to email address</mat-option>
                                        <mat-option value="Delete">Delete message</mat-option>
                                        <mat-option value="Quarantine">Quarantine message</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="outline"
                                    *ngIf="formValue?.HighConfidenceSpamAction === 'Quarantine'">
                                    <mat-label>Quarantine Policy</mat-label>
                                    <mat-select formControlName="HighConfidenceSpamQuarantineTag">
                                        <mat-option *ngFor="let policy of quarantinePolicyLookup$ | async"
                                            [value]="policy.Name">
                                            {{policy.Name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('HighConfidenceSpamQuarantineTag!') || errorsString.includes('HighConfidenceSpamAction!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>Phishing</td>
                            <td>{{spamActionLabels[defaultPolicy?.PhishSpamAction] ?? defaultPolicy?.PhishSpamAction}}
                            </td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="PhishSpamAction">
                                        <mat-option value="MoveToJmf">Move message to junk email folder</mat-option>
                                        <mat-option value="AddXHeader">Add X-header</mat-option>
                                        <mat-option value="ModifySubject">Prepend subject line with text</mat-option>
                                        <mat-option value="Redirect">Redirect message to email address</mat-option>
                                        <mat-option value="Delete">Delete message</mat-option>
                                        <mat-option value="Quarantine">Quarantine message</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="outline"
                                    *ngIf="formValue?.PhishSpamAction === 'Quarantine'">
                                    <mat-label>Quarantine Policy</mat-label>
                                    <mat-select formControlName="PhishQuarantineTag">
                                        <mat-option *ngFor="let policy of quarantinePolicyLookup$ | async"
                                            [value]="policy.Name">
                                            {{policy.Name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('PhishSpamAction!') || errorsString.includes('/PhishQuarantineTag!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>High Confidence Phishing</td>
                            <td>{{spamActionLabels[defaultPolicy?.HighConfidencePhishAction] ??
                                defaultPolicy?.HighConfidencePhishAction}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="HighConfidencePhishAction">
                                        <mat-option value="Quarantine">Quarantine message</mat-option>
                                        <mat-option value="Redirect">Redirect message to email address</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="outline"
                                    *ngIf="formValue?.HighConfidencePhishAction === 'Quarantine'">
                                    <mat-label>Quarantine Policy</mat-label>
                                    <mat-select formControlName="HighConfidencePhishQuarantineTag">
                                        <mat-option *ngFor="let policy of quarantinePolicyLookup$ | async"
                                            [value]="policy.Name">
                                            {{policy.Name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('HighConfidencePhishQuarantineTag!') || errorsString.includes('HighConfidencePhishAction!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>Bulk complaint level (BCL) met or exceeded</td>
                            <td>{{spamActionLabels[defaultPolicy?.BulkSpamAction] ?? defaultPolicy?.BulkSpamAction}}
                            </td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="BulkSpamAction">
                                        <mat-option value="MoveToJmf">Move message to junk email folder</mat-option>
                                        <mat-option value="AddXHeader">Add X-header</mat-option>
                                        <mat-option value="ModifySubject">Prepend subject line with text</mat-option>
                                        <mat-option value="Redirect">Redirect message to email address</mat-option>
                                        <mat-option value="Delete">Delete message</mat-option>
                                        <mat-option value="Quarantine">Quarantine message</mat-option>
                                        <mat-option value="NoAction">No action</mat-option>
                                    </mat-select>
                                </mat-form-field>

                                <mat-form-field appearance="outline" *ngIf="formValue?.BulkSpamAction === 'Quarantine'">
                                    <mat-label>Quarantine Policy</mat-label>
                                    <mat-select formControlName="BulkQuarantineTag">
                                        <mat-option *ngFor="let policy of quarantinePolicyLookup$ | async"
                                            [value]="policy.Name">
                                            {{policy.Name}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('BulkSpamAction!') || errorsString.includes('BulkQuarantineTag!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>Intra-Organizational messages to take action on</td>
                            <td>{{intraOrgFilterStateLabels[defaultPolicy?.IntraOrgFilterState] ?? defaultPolicy?.IntraOrgFilterState}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="IntraOrgFilterState">
                                        <!-- <mat-option value="Default">Default</mat-option> -->
                                        <mat-option value="Disabled">None</mat-option>
                                        <mat-option value="HighConfidencePhish">High Confidence phishing messages</mat-option>
                                        <mat-option value="Phish">Phishing and high Confidence phishing messages</mat-option>
                                        <mat-option value="HighConfidenceSpam">All phishing and high-confidence spam messages</mat-option>
                                        <mat-option value="Spam">All phishing and spam messages</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('IntraOrgFilterState!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr>
                            <td>Retain Spam in Quarantine (days)</td>
                            <td>{{defaultPolicy?.QuarantineRetentionPeriod}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <input matInput type="number" formControlName="QuarantineRetentionPeriod" min="1"
                                        max="30" />
                                    <mat-error *ngIf="form.get('QuarantineRetentionPeriod').hasError('required')">Value
                                        is required</mat-error>
                                    <mat-error *ngIf="form.get('QuarantineRetentionPeriod').hasError('min')">Minimum
                                        value is 1</mat-error>
                                    <mat-error *ngIf="form.get('QuarantineRetentionPeriod').hasError('max')">Maximum
                                        value is 30</mat-error>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('QuarantineRetentionPeriod!')"></sway-baseline-status>
                            </td>
                        </tr>


                        <tr *ngIf="isAddXHeaderSelected">
                            <td>Add this X-header text</td>
                            <td>{{defaultPolicy?.AddXHeaderValue}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="AddXHeaderValue" />
                                    <mat-error *ngIf="form.get('AddXHeaderValue').hasError('required')">Value is
                                        required</mat-error>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('AddXHeaderValue!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr *ngIf="isModifySubjectSelected">
                            <td>Prepend subject line with this text</td>
                            <td>{{defaultPolicy?.ModifySubjectValue}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="ModifySubjectValue" />
                                    <mat-error *ngIf="form.get('ModifySubjectValue').hasError('required')">Value is
                                        required</mat-error>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('ModifySubjectValue!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr *ngIf="isRedirectSelected">
                            <td>Redirect to this email address</td>
                            <td>{{defaultPolicy?.RedirectToRecipients}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <input matInput formControlName="RedirectToRecipients" />
                                    <mat-error *ngIf="form.get('RedirectToRecipients').hasError('required')">Value is
                                        required</mat-error>
                                         <mat-error *ngIf="form.get('RedirectToRecipients').hasError('email')"> Invalid email</mat-error>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="hasRedirectToRecipientsError"></sway-baseline-status>
                            </td>
                        </tr>


                        <tr>
                            <td>Enable Spam Safety Tips <mat-icon
                                    [matTooltip]="tooltips.InlineSafetyTipsEnabled">info</mat-icon></td>
                            <td>{{defaultPolicy?.InlineSafetyTipsEnabled ? 'Enabled' : 'Disabled'}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="InlineSafetyTipsEnabled">
                                        <mat-option [value]="true">Enabled</mat-option>
                                        <mat-option [value]="false">Disabled</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('InlineSafetyTipsEnabled!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr >
                            <td>Enable ZAP for Phishing Messages</td>
                            <td>{{defaultPolicy?.PhishZapEnabled ? 'Enabled' : 'Disabled'}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="PhishZapEnabled">
                                        <mat-option [value]="true">Enabled</mat-option>
                                        <mat-option [value]="false">Disabled</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('PhishZapEnabled!')"></sway-baseline-status>
                            </td>
                        </tr>

                        <tr >
                            <td>Enable ZAP for Spam Messages</td>
                            <td>{{defaultPolicy?.SpamZapEnabled ? 'Enabled' : 'Disabled'}}</td>
                            <td>
                                <mat-form-field appearance="outline">
                                    <mat-select formControlName="SpamZapEnabled">
                                        <mat-option [value]="true">Enabled</mat-option>
                                        <mat-option [value]="false">Disabled</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td><sway-baseline-status
                                    [hasError]="errorsString.includes('SpamZapEnabled!')"></sway-baseline-status>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-expansion-panel>

        <!-- Section 5: Allowed and Blocked Senders and Domains -->
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full flex justify-between">
                    <mat-panel-title class="font-bold">
                        Allowed and Blocked Senders and Domains
                    </mat-panel-title>
                    <div>
                        <sway-baseline-status [hasError]="errorsString.includes('AllowedSenders') || errorsString.includes('AllowedSenderDomains') || errorsString.includes('BlockedSenders') || errorsString.includes('BlockedSenderDomains')"></sway-baseline-status>
                    </div>
                </div>
            </mat-expansion-panel-header>

            <div>
                <table>
                    <thead>
                        <tr>
                            <th>Field</th>
                            <th>Current Value</th>
                            <th>Desired Value</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Always Deliver Messages from These Senders</td>
                            <td>{{defaultPolicy?.AllowedSenders?.join(', ') || '-'}}</td>
                            <td>
                                <ng-container *ngIf="!readOnly || override?.includes('AllowedSenders'); else allowedSendersReadonly">
                                    <ng-select
                                        formControlName="AllowedSenders"
                                        [multiple]="true"
                                        [addTag]="addEmailTag"
                                        addTagText="Add email address"
                                        [appendTo]="'body'"
                                        placeholder="e.g. user@contoso.com">
                                    </ng-select>
                                    <small class="hint">Type a valid email address and press Enter</small>
                                </ng-container>
                                <ng-template #allowedSendersReadonly>
                                    <span>{{form.get('AllowedSenders').value?.join(', ') || '-'}}</span>
                                </ng-template>
                            </td>
                            <td><sway-baseline-status [hasError]="errorsString.includes('AllowedSenders')"></sway-baseline-status></td>
                        </tr>

                        <tr>
                            <td>Always Deliver Messages from These Domains</td>
                            <td>{{defaultPolicy?.AllowedSenderDomains?.join(', ') || '-'}}</td>
                            <td>
                                <ng-container *ngIf="!readOnly || override?.includes('AllowedSenderDomains'); else allowedSenderDomainsReadonly">
                                    <ng-select
                                        formControlName="AllowedSenderDomains"
                                        [multiple]="true"
                                        [addTag]="addDomainTag"
                                        addTagText="Add domain"
                                        [appendTo]="'body'"
                                        placeholder="e.g. contoso.com">
                                    </ng-select>
                                    <small class="hint">Type a valid domain and press Enter</small>
                                </ng-container>
                                <ng-template #allowedSenderDomainsReadonly>
                                    <span>{{form.get('AllowedSenderDomains').value?.join(', ') || '-'}}</span>
                                </ng-template>
                            </td>
                            <td><sway-baseline-status [hasError]="errorsString.includes('AllowedSenderDomains')"></sway-baseline-status></td>
                        </tr>

                        <tr>
                            <td>Block Messages from These Senders</td>
                            <td>{{defaultPolicy?.BlockedSenders?.join(', ') || '-'}}</td>
                            <td>
                                <ng-container *ngIf="!readOnly || override?.includes('BlockedSenders'); else blockedSendersReadonly">
                                    <ng-select
                                        formControlName="BlockedSenders"
                                        [multiple]="true"
                                        [addTag]="addEmailTag"
                                        addTagText="Add email address"
                                        [appendTo]="'body'"
                                        placeholder="e.g. user@contoso.com">
                                    </ng-select>
                                    <small class="hint">Type a valid email address and press Enter</small>
                                </ng-container>
                                <ng-template #blockedSendersReadonly>
                                    <span>{{form.get('BlockedSenders').value?.join(', ') || '-'}}</span>
                                </ng-template>
                            </td>
                            <td><sway-baseline-status [hasError]="errorsString.includes('BlockedSenders')"></sway-baseline-status></td>
                        </tr>

                        <tr>
                            <td>Block Messages from These Domains</td>
                            <td>{{defaultPolicy?.BlockedSenderDomains?.join(', ') || '-'}}</td>
                            <td>
                                <ng-container *ngIf="!readOnly || override?.includes('BlockedSenderDomains'); else blockedSenderDomainsReadonly">
                                    <ng-select
                                        formControlName="BlockedSenderDomains"
                                        [multiple]="true"
                                        [addTag]="addDomainTag"
                                        addTagText="Add domain"
                                        [appendTo]="'body'"
                                        placeholder="e.g. contoso.com">
                                    </ng-select>
                                    <small class="hint">Type a valid domain and press Enter</small>
                                </ng-container>
                                <ng-template #blockedSenderDomainsReadonly>
                                    <span>{{form.get('BlockedSenderDomains').value?.join(', ') || '-'}}</span>
                                </ng-template>
                            </td>
                            <td><sway-baseline-status [hasError]="errorsString.includes('BlockedSenderDomains')"></sway-baseline-status></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-expansion-panel>

    </mat-accordion>

</form>

<ng-template #notFound>
    <p>Default anti spam inbound policy not found.</p>
</ng-template>
